<svg width="62" height="81" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M.5 69.677V26.253L25.962.5h25.705c1.62 0 2.944 1.33 2.944 2.984v66.193c0 1.654-1.324 2.984-2.944 2.984H3.444c-1.62 0-2.944-1.33-2.944-2.984z"
    [attr.fill]="url('paint0_linear')"
    stroke="#DDDDE4"
  />
  <path
    d="M25.253 22.564c0 1.653-1.324 2.984-2.945 2.984H1.198L25.252 1.217v21.347z"
    fill="#545477"
    fill-opacity=".05"
    stroke="#DDDDE4"
  />
  <path
    d="M7.389 77.515V34.091L32.85 8.338h25.705c1.621 0 2.945 1.33 2.945 2.984v66.193c0 1.653-1.324 2.984-2.945 2.984H10.333c-1.62 0-2.944-1.33-2.944-2.984z"
    [attr.fill]="url('paint1_linear')"
    stroke="#DDDDE4"
  />
  <path
    d="M32.142 30.402c0 1.653-1.324 2.984-2.945 2.984H8.087L32.141 9.055v21.347z"
    fill="#545477"
    fill-opacity=".05"
    stroke="#DDDDE4"
  />
  <defs>
    <linearGradient
      [attr.id]="id('paint0_linear')"
      x1="793.27"
      y1="3426.08"
      x2="829.808"
      y2="3456.38"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#8D8DAF" stop-opacity=".05" />
      <stop offset="1" stop-color="#545477" stop-opacity=".05" />
    </linearGradient>
    <linearGradient
      [attr.id]="id('paint1_linear')"
      x1="800.158"
      y1="3433.91"
      x2="836.697"
      y2="3464.22"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#F6F6F8" />
      <stop offset="1" stop-color="#545477" stop-opacity=".05" />
    </linearGradient>
  </defs>
</svg>
